import React from 'react';
import { useDragLayer } from 'react-dnd';
import PF2MEquipIcon from '~/components/PF2MEquipIcon';
import { DispatchDragNDropTypes, DispatchOperationType } from '~/utils';

const getDragLayerStyles = (initialOffset, currentOffset) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    opacity: '1 !important',
    WebkitTransform: transform,
  };
};

const isReverse = truckOrigin => [
  DispatchOperationType.UNLOAD,
  DispatchOperationType.UNLOAD_MANEUVER,
  DispatchOperationType.UNLOAD_QUEUE,
  DispatchOperationType.UNLOAD_TRAFFIC,
].includes(truckOrigin.operation_type);

const PF2MCustomDragLayer = () => {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset,
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const renderItem = () => {
    switch (itemType) {
      case DispatchDragNDropTypes.TRUCK:
        return (
          <PF2MEquipIcon
            extraInfo={''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.TRUCK}
            reverse={isReverse(item.obj)}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.LOAD:
        return (
          <PF2MEquipIcon
            extraInfo={''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.LOAD}
            reverse={false}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );

      case DispatchDragNDropTypes.ORIGIN_TRUCK:
        return (
          <PF2MEquipIcon
            extraInfo={item.obj.load_allocation_excavator_name || ''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.ORIGIN_TRUCK}
            reverse={isReverse(item.obj)}
            useOperationType
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.ORIGIN_LOAD:
        return (
          <PF2MEquipIcon
            extraInfo={''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.ORIGIN_LOAD}
            reverse={false}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.DESTINATION_TRUCK:
        return (
          <PF2MEquipIcon
            extraInfo={item.obj.destination_point_name || ''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.DESTINATION_TRUCK}
            reverse={isReverse(item.obj)}
            useOperationType
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.POOL_TRUCK:
        return (
          <PF2MEquipIcon
            extraInfo={item.obj.destination_point_name || ''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.POOL_TRUCK}
            reverse={false}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.POOL_LOAD:
        return (
          <PF2MEquipIcon
            extraInfo={item.obj.destination_point_name || ''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.POOL_LOAD}
            reverse={false}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );
      case DispatchDragNDropTypes.PERFORATOR:
        return (
          <PF2MEquipIcon
            extraInfo={''}
            item={item.obj}
            itemType={DispatchDragNDropTypes.PERFORATOR}
            reverse={isReverse(item.obj)}
            useOperationType={false}
            onClick={() => null}
            warningType={''}
          />
        );
      default:
        return null;
    }
  };

  if (!isDragging) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      pointerEvents: 'none',
      zIndex: 100,
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
    }}
    >
      <div style={getDragLayerStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
};

export default PF2MCustomDragLayer;
